export enum Culture {
    Mexico,
    India,
    Egypt,
    NumElements,
}
